@file:OptIn(ExperimentalUuidApi::class)

package org.dronda.app.web.ui.locationconfig

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.dronda.app.web.ui.components.ControlledInput
import org.dronda.app.web.ui.components.StyledButton
import org.dronda.app.web.ui.util.rememberWindowSize
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import kotlin.uuid.ExperimentalUuidApi

@Composable
fun LocationConfigScreen(
    locationConfigViewModel: LocationConfigViewModel,
) {
    val uiState by locationConfigViewModel.uiState.collectAsState()
    val windowSize by rememberWindowSize()
    val mainWidth by remember(windowSize) {
        mutableStateOf(
            if (windowSize.width > 800) {
                70.percent
            } else {
                90.percent
            }
        )
    }
    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(top = 50.px),
        horizontalArrangement = Arrangement.Center,
    ) {
        Column(
            modifier = Modifier.width(mainWidth),
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            LocationFriendView(
                uiState.locationSharingFriends,
                deleteLocationSharingFriend = {
                    locationConfigViewModel.take(LocationConfigViewModel.Event.DeleteLocationSharingFriend(it.id))
                }
            )
            DownloadConfigurationView(
                onOpen = { locationConfigViewModel.take(LocationConfigViewModel.Event.OpenOwntracksLink(it))}
            )
        }
    }
}

@Composable
private fun LocationFriendView(
    locationSharingFriends: List<LocationSharingFriend>,
    deleteLocationSharingFriend: (LocationSharingFriend) -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        H2(
            Modifier
                .fontWeight(FontWeight.Thin)
                .padding(leftRight = 10.px, topBottom = 10.px)
                .toAttrs()
        ) {
            Text("Location Sharing")
        }

        Card {
            locationSharingFriends.forEachIndexed { index, locationSharingFriend ->
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .height(2.cssRem)
                        .padding(topBottom = 40.px, leftRight = 30.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Text(locationSharingFriend.email)

                    StyledButton(
                        "Remove",
                        modifier = Modifier.minHeight(48.px),
                        onClick = {
                            deleteLocationSharingFriend(locationSharingFriend)
                        }
                    )
                }
                if (index != locationSharingFriends.lastIndex) {
                    Div(
                        Modifier.fillMaxWidth()
                            .backgroundColor(rgb(214, 214, 214))
                            .height(1.px)
                            .toAttrs()
                    )
                }
            }
        }
    }
}

@Composable
fun DownloadConfigurationView(
    onOpen: (password: String) -> Unit
) {
    val password = remember { mutableStateOf("") }

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        H2(
            Modifier
                .fontWeight(FontWeight.Thin)
                .padding(leftRight = 10.px, topBottom = 10.px)
                .toAttrs()
        ) {
            Text("Download Config")
        }

        Card {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(topBottom = 20.px, leftRight = 30.px),
                verticalArrangement = Arrangement.spacedBy(1.cssRem),
            ) {
                P(
                    Modifier.fontWeight(350)
                        .fontSize(0.9.cssRem)
                        .toAttrs()
                ) {
                    Text("Enter your password and then hit open to autoload the Owntracks configuration. Note that if the app isn't installed, nothing will happen.")
                }
                Row(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    ControlledInput(
                        textState = password,
                        label = "Password",
                        labelId = "password-input",
                        inputType = InputType.Password,
                    )

                    StyledButton(
                        "Open",
                        modifier = Modifier.minHeight(48.px),
                        onClick = { onOpen(password.value) }
                    )
                }
            }
        }
    }
}


@Composable
private fun Card(content: @Composable (ColumnScope) -> Unit) {
    Column(
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(Colors.White)
            .borderRadius(6.px),
        content = content
    )
}
